const STORAGE_KEY = "pending-site-import"
const MAX_AGE_MS = 1000 * 60 * 60 * 24

interface PendingSiteImport {
	url: string
	capturedAt: number
}

function readRaw(): PendingSiteImport | null {
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (!raw) return null
		const parsed = JSON.parse(raw) as Partial<PendingSiteImport>
		if (typeof parsed?.url !== "string" || !parsed.url) return null
		if (typeof parsed.capturedAt !== "number") return null
		return { url: parsed.url, capturedAt: parsed.capturedAt }
	} catch {
		return null
	}
}

/** Keeps the help center address a visitor typed on the marketing hero across the signup roundtrip. */
export function capturePendingSiteImport(search: string): string | null {
	const url = new URLSearchParams(search).get("docs")?.trim()
	if (!url) return null

	try {
		localStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({ url, capturedAt: Date.now() }),
		)
	} catch {
		return null
	}
	return url
}

export function readPendingSiteImport(now = Date.now()): string | null {
	const pending = readRaw()
	if (!pending) return null
	if (now - pending.capturedAt > MAX_AGE_MS) {
		clearPendingSiteImport()
		return null
	}
	return pending.url
}

export function clearPendingSiteImport(): void {
	try {
		localStorage.removeItem(STORAGE_KEY)
	} catch {
		// A blocked storage means there is nothing to clear.
	}
}
